import { ChangeEvent, KeyboardEvent, useCallback, useState } from "react"
import { ClassProps } from "../../utility/common/props"
import cn from "classnames"
import { faSearch, faTimes } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import LoadingButton from "../LoadingButton/LoadingButton"
import { Button, FormControl, FormCheck } from "react-bootstrap"
import { formTranslation } from "../../locales/form"
import "./SearchArticlesInput.scss"
import debounce from "lodash/debounce"
import { useTranslation } from "react-i18next"

const tNamespace = "knowledgeBase:search-articles."

export interface SearchArticlesInputProps extends ClassProps {
    query: string
    enableRemoved: boolean
    loading: boolean
    onSearch: () => void
    onClear: () => void
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
    onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void
    onEnableRemoved: () => void
    isFiltersEnabled: boolean
}

export const SearchArticlesInput = (props: SearchArticlesInputProps) => {
    const {
        query,
        loading,
        onSearch,
        onClear,
        onChange,
        onKeyDown,
        className,
        enableRemoved,
        onEnableRemoved,
        isFiltersEnabled
    } = props
    const [searchValue, setSearchValue] = useState<string>(query)
    const { t } = useTranslation()

    const handleChangeCallback = useCallback(
        debounce((e: ChangeEvent<HTMLInputElement>) => {
            onChange(e)
        }, 800),
        []
    )

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        handleChangeCallback(e)
        setSearchValue(e.target.value)
    }

    const handleClear = () => {
        setSearchValue("")
        onClear()
    }

    return (
        <div className="search-articles-input-container">
            <div className={cn("search-articles-input", className)}>
                <LoadingButton
                    className="search-articles-input__search"
                    loading={loading}
                    variant="link"
                    disabled={!query}
                    onClick={onSearch}
                >
                    <FontAwesomeIcon icon={faSearch} size="1x" />
                </LoadingButton>

                <FormControl
                    type="text"
                    name="search-articles"
                    value={searchValue}
                    onKeyDown={onKeyDown}
                    onChange={handleChange}
                    placeholder={t(formTranslation.search)}
                    className="search-articles-input__query"
                />

                {(query || isFiltersEnabled) && !loading && (
                    <Button className="search-articles-input__clear" variant="link" onClick={handleClear}>
                        <div className="search-articles-input__clear-icon">
                            <FontAwesomeIcon icon={faTimes} size="1x" />
                        </div>
                    </Button>
                )}
            </div>
            {query && (
                <FormCheck
                    custom
                    id="enable-removed"
                    label={t(`${tNamespace}enable-removed`)}
                    checked={enableRemoved}
                    onChange={onEnableRemoved}
                    className="search-articles-input-container__enable-removed"
                />
            )}
        </div>
    )
}
